import { render, staticRenderFns } from "./CreateItemChildModalForm.vue?vue&type=template&id=5ecf919a"
import script from "./CreateItemChildModalForm.vue?vue&type=script&lang=js"
export * from "./CreateItemChildModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports